import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent} from "@wms/components";
import {FormsModule} from "@angular/forms";
import {filter, forEach, get, includes, isArray, keys} from "lodash-es";
import {getWidgetRolesArrayFromStr} from "@wms/core";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { CommonWidgetDirective } from "@wms/directives";

@Component({
  selector: 'wms-role-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, BsDropdownModule, CommonWidgetDirective],
  templateUrl: './role-selector.component.html',
  styleUrls: ['./role-selector.component.less']
})
export class RoleSelectorComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() hideGroups: boolean;
  @Input() showGroups: boolean = false;
  @Input() mode: string = 'list';
  @Input() currentPage? :any
  @Input() hideAnonymous?: boolean;
  groups: any;
  valueChanged: boolean = false;
  _model: any = {};
  _ovRadioModel: any;
  @Input() roles:any;
  @Input() model: any;
  isRoleselector: any;
  @Input() isProperty: any;
  @Output() onChange:EventEmitter<any> = new EventEmitter();
  selectedText: any;
  constructor() {
    super();
    this.groups = ['Everyone', 'Anonymous', 'Authenticated'];
    this.valueChanged = false;
    this._model = {};
  }

  ngOnInit(): void {
    if (this.hideAnonymous) {
      this.groups = ['Everyone', 'Authenticated'];
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    let nv = (changes['model'] && changes['model'].currentValue) || this.model;
    let _nv;
    this._model.checkboxModel = {};
    this._model.radioModel = '';
    /*In properties panel the markup as comma separated string where as in security it is saved as array*/
    if (!isArray(nv)) {
      _nv = getWidgetRolesArrayFromStr(nv)
    } else{
      _nv = nv;
    }
    if (_nv.length) {
      if (_nv.length === 1) {
        if (includes(this.groups, _nv[0])) {
          this._model.radioModel = this._ovRadioModel = _nv[0];
        } else {
          this._model.checkboxModel[_nv[0]] = true;
        }
      } else {
        forEach(_nv, (key) => {
          this._model.checkboxModel[key] = true;
        });
      }
    } else if(this.isRoleselector) {
      /*If not no role is chosen, default choosing
      In properties panel >> 'Everyone'
      In security dialog  >> 'Authenticated'
      */
      this._model.radioModel = nv = this._ovRadioModel || (this.isProperty ? 'Everyone' : 'Authenticated');
    }
    this.selectedText = this.updateMultiSelectText(keys(this._model.checkboxModel));
  }

  private updateMultiSelectText(checkboxModelKeys: string[]) {
    let accessText;
    if (this._model.radioModel) {
      accessText = this._model.radioModel;
    } else {
      accessText = checkboxModelKeys.join(',');
    }
    return accessText;
  }

  onCheckboxModelChange() {
    if(this._model.checkboxModel) {
      this._model.radioModel = '';
    }
    this.triggerOnChange();
  }

  private triggerOnChange() {
    let  _model = [],
      _keys = keys(this._model.checkboxModel);
    if (this._model.radioModel) {
      _model = this.isProperty ? this._model.radioModel : [this._model.radioModel];
    } else if (_keys.length) {
      _model = filter(_keys, (key) => {return this._model.checkboxModel[key]; });
    }

    // retain the previous state of the selection when all the checkboxes are unselected.
    if (!_model.length && this._ovRadioModel) {
      _model = [this._ovRadioModel];
    }
    this.selectedText = this.updateMultiSelectText(_model);

    this.model = _model;
    // this.onChange({$model: _model});
    this.valueChanged = true;
    this.onChange.emit(this.model);
  }

  onRadioModelChange() {
    if (this._model.radioModel) {
      this._model.checkboxModel = {};
    }
    this.triggerOnChange();
  }

  getModel(role: any): any {
    return this._model.radioModel;
  }
}
